import React, { useEffect, useState } from "react";
import { emitter } from "./editorUtils/editorUtils";
import { EventSource } from "eventsource";
import { useKeycloak } from "@react-keycloak/web";
import { moduleApiEndPoint } from "../services/axiosConfig";
const GlobaleEventListener = () => {
  const { keycloak } = useKeycloak();
  useEffect(() => {
    if (!keycloak.token) {
      return;
    }

    const resoureUrl = `${moduleApiEndPoint}veeva/mlr/event?token=${encodeURIComponent(
      keycloak.token
    )}`;
    const eventSourceInitDict = {
      https: { rejectUnauthorized: false },
      headers: { withCredentials: true },
    };
    let failureCount = 0;
    const es = new EventSource(resoureUrl, eventSourceInitDict);

    es.onmessage = (e) => {
      let data = JSON.parse(e.data)
      console.log(data, "event recieved")
      if (data?.type && data.type === "PDF_TO_HTML_CONVERSION") {
        emitter.emit("pdfToHtml", data)
      } else {
        failureCount = 0;
        emitter.emit("autoSync", e.data);
      }
    };

    es.onerror = function (err) {
      if (err) {
        if (err.status === 401 || err.status === 403) {
          console.log("not authorized");
        }
        failureCount++;
        if (failureCount >= 3) {
          // sessionStorage.setItem("backendFailed", "true");
          // window.location.href = "/server-maintenance";
          console.log("failureCount", failureCount);
        }
      }
    };

    return () => {
      es.close();
      emitter.off("autoSync");
      emitter.off("pdfToHtml")
    };
  }, []);
  return null;
};
export default GlobaleEventListener;
